import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOrgUnitNonAthleteEntryCredentialsSelectionData from './GetOrgUnitNonAthleteEntryCredentialsSelectionData';
import postOrgUnitNonAthleteEntryCredentialsSelectionData from './PostOrgUnitNonAthleteEntryCredentialsSelectionData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData = {
  INITIAL_STATE, getOrgUnitNonAthleteEntryCredentialsSelectionData, postOrgUnitNonAthleteEntryCredentialsSelectionData
}

export default OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData;